/**
 * PaymentMethod Entity Definition
 */
import { PaymentMethodRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
import { getLazyUserEntityDef } from "./lazy-refs";
export const PaymentMethodEntityDef = defineEntity({
    name: "payment-method",
    schema: PaymentMethodRelationSchema,
    relations: {
        pm_owner: { type: "one", entity: getLazyUserEntityDef },
    },
});
